import kebabCase from 'lodash-es/kebabCase'
import { useField } from 'vee-validate'
import { computed, toRef, watch } from 'vue'
import type { TTextareaProps } from './types'
import type { SetupContext } from 'vue'

/**
 *
 * @param props
 * @param context
 */
export function setup(
  props: TTextareaProps,
  context: SetupContext<['blur', 'keyup', 'update:modelValue']>
) {
  if (!props.name) {
    throw new Error(
      'TTextarea: unique name prop (used as HTML attr id) is required'
    )
  }

  const rules = toRef(() => props.rules)

  const {
    value: inputValue,
    handleBlur,
    handleChange,
    meta,
    errors,
  } = useField(props.name, rules, {
    initialValue: props.modelValue,
  })

  const onInput = (e: any) => {
    handleChange(e)
    context.emit('update:modelValue', inputValue.value)
  }

  const onBlur = (e: any) => {
    handleBlur(e)
    context.emit('blur', e)
  }

  const isInvalid = computed(() => !!errors.value.length && meta.touched)

  /*
      This watch function ensures updates happen outside component.
      Without this, if updating a TTextarea that is sharing values with
      another TTextarea in a different parent component, it'll only
      update for the current TTextarea in current parent component
      */
  watch(
    () => props.modelValue,
    (modelValue) => handleChange(modelValue)
  )

  const testId = props.testId || `${kebabCase(props.name)}-textarea`

  return {
    inputValue,
    handleBlur,
    onBlur,
    onInput,
    testId,
    meta,
    errors,
    isInvalid,
  }
}
